import { render, staticRenderFns } from "./SwiperContainer.vue?vue&type=template&id=0d1b260a&scoped=true"
import script from "./SwiperContainer.vue?vue&type=script&lang=ts"
export * from "./SwiperContainer.vue?vue&type=script&lang=ts"
import style0 from "./SwiperContainer.vue?vue&type=style&index=0&id=0d1b260a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1b260a",
  null
  
)

export default component.exports